module.exports = __webpack_public_path__ + "img/user_headset.b1783de2.svg";